// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vl-radio__wrapper__indent[data-v-b407e2d6] {
  margin-left: 30px;
}
.vl-input__wrapper__indent[data-v-b407e2d6] {
  margin-left: 30px;
}
.vl-form__group[data-v-b407e2d6] {
  margin-top: 0;
  padding: 3rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
